const header = document.querySelector('.header');

if (header) {
  const onScroll = () => {
    const scrolled = window.scrollY > 50;
    header.classList.toggle('header--scroll', scrolled);
    document.body.classList.toggle('header--scroll', scrolled);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
}
